import {SlotMachine} from "../slot-machine";
import Api from "../../lib/api";
import {randomIntFromInterval, randomIntFromIntervalWithStep} from "../../lib";

export default class Gift2025Section {
    constructor() {
        this.$root = document.querySelector('.section.-gift2025');

        if (this.$root) {
            this.$slotMachine = document.getElementById('gift2025-total-gifted');

            this.slotMachine = new SlotMachine(this.$slotMachine, { tMax: 3000 });

            this.init();
        }
    }

    init() {
        Api.get(Api.lmsApiUrl + '/new_year_2025/total_discounts')
            .then(({ success, response }) => {
                if (!success || !response.total) {
                    return;
                }

                this.slotMachine.init(+response.total);
                this.slotMachine.action();

                this.fakeTotalDiscountUpdate();
                this.addEventListeners();
            });
    }

    addEventListeners() {
        window.addEventListener('gift2025TotalDiscountUpdated', ({ detail }) => {
            if (!detail && !isNaN(+detail)) {
                return;
            }

            const newTarget = +this.slotMachine.target + +detail;
            this.slotMachine.updateTargetAndRun(newTarget, { tMax: 500 });
        });


        window.addEventListener('blur', () => {
            clearTimeout(this.timeoutId);
        });
        window.addEventListener('focus', () => {
            clearTimeout(this.timeoutId);
            this.fakeTotalDiscountUpdate();
        });
    }

    fakeTotalDiscountUpdate() {
        this.timeoutId = setTimeout(() => {
            const newTarget = +this.slotMachine.target + 2025;
            this.slotMachine.updateTargetAndRun(newTarget, { tMax: 500 });
            this.fakeTotalDiscountUpdate();
        }, randomIntFromInterval(15000, 60000));
    }
}